import ModalNotification from './ModalNotification';

export default ModalNotification;
